// extracted by mini-css-extract-plugin
module.exports = {"CreateAccount":"_17IWq","MinHeight":"eBySG","container768":"IjvvU","topSpace80":"_3G6e3","title":"Wlnya","congratulations":"_1IBDM","topSpace50":"QJ05G","nextButton":"_1-ViY"};